/**
 * Strip the "None" sentinel out of a session before it is sent.
 *
 * The faction select holds 0 for "None", and 0 matches no Faction row, so
 * Postgres rejects the foreign key and the whole save fails with a 400 - on
 * every session where any player had no faction chosen.
 *
 * Done here rather than in the zod schema on purpose: a `.transform` on the
 * field makes the key *required* in the inferred type, which breaks every
 * upstream test fixture that builds a player session by hand. The wire is the
 * right place for a wire concern anyway.
 */
export const stripEmptyFactions = <T extends { playerSessions?: unknown }>(session: T): T => ({
	...session,
	playerSessions: (session.playerSessions as { factionId?: number }[] | undefined)?.map((playerSession) => ({
		...playerSession,
		factionId: playerSession.factionId ? playerSession.factionId : undefined,
	})),
});
